import AutomationHelper from '../../../../mixins/AutomationHelper';
export default {
  props: {
    step: {
      type: Object,
      required: true,
    },
  },
  mixins: [AutomationHelper],
  data() {
    return {
      localStep: {},
    };
  },
  watch: {
    step: {
      handler() {
        this.resetLocalStep();
      },
      //   deep: true,
      immediate: true,
    },
  },
  methods: {
    resetLocalStep() {
      this.localStep = JSON.parse(JSON.stringify(this.step || {}));
      let valid = this.validateSingleAction(this.localStep, false);
      this.$set(this.step, 'valid', valid);
    },
    saveChanges() {
      let valid = this.validateSingleAction(this.localStep, false);
      if (!valid) {
        return this.$message.error('Please fill all required Fields');
      }
      this.$set(this.localStep, 'valid', true);
      this.$emit('update:step', JSON.parse(JSON.stringify(this.localStep)));
    },
    cancelChanges() {
      //   this.resetLocalStep();
      //   this.localStep = JSON.parse(JSON.stringify(this.step || {}));
      this.$emit('close:step');
    },
  },
};
